import "@hotwired/turbo"
import "bootstrap"

document.addEventListener("turbo:load", function(){
  if(typeof gon !== 'undefined' && gon.request_id != null) {
    console.log("リクエストID：" + gon.request_id);
    gon.request_id = null;
  }
})
